import * as React from 'react';
import { connect } from 'react-redux';
import { Tools } from '../components';
import { AdminTool } from '../components';
import { saveHelper, publishHelper, EModalType, IComponent, EConfirmationOperationType, FeatureHelper } from '../helpers';
import store from '../store/store';
import types from '../store/types';

interface iProps{
    searchState:any;
    adminToolState:any;
}
class AdminToolContainer extends React.Component<any, any> {
    public render() {
        console.log('admin state --->', store.getState());

        return (
            <AdminTool adminToolState={this.props.adminToolState} searchState={this.props.searchState} sidebarState={this.props.adminToolState.sidebar}/>
        );
    }
};


let mapStateToProps = (store) => {
    return {
        searchState: store.searchState,
        adminToolState: store.adminToolState
    };
};

export default connect<any, any, any>(mapStateToProps)(AdminToolContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/admintool-container.tsx